var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationSs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 108,
    viewBox: "0 0 135 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4593 22.0672C70.4593 22.0672 66.0162 -2.3939 77.208 0.191259C88.3997 2.77641 81.6509 24.6523 81.6509 24.6523L70.4593 22.0672Z",
    fill: "url(#paint0_radial_638_1450)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.3814 0.549871C74.6392 0.598955 75.8761 0.885604 77.0263 1.39454C79.8386 2.65014 82.0022 5.15227 83.1007 8.01793C83.224 8.36867 83.3671 8.71219 83.5293 9.04688C83.073 4.83111 81.3979 1.15885 77.2076 0.190943C75.6457 -0.169706 74.3888 -0.00280762 73.3814 0.549871Z",
    fill: "#FFADEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.03 54.7088C101.03 54.7088 101.354 48.1352 106.157 47.6946C110.96 47.2539 136.224 61.649 134.954 67.1152C133.683 72.5814 99.97 58.8517 101.03 54.7088Z",
    fill: "url(#paint1_radial_638_1450)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7618 55.7788C52.7618 55.7788 52.8546 49.198 48.0891 48.4572C43.3235 47.7164 17.1984 60.5 18.1212 66.0354C19.0441 71.5708 53.5578 59.9799 52.7618 55.7788Z",
    fill: "url(#paint2_radial_638_1450)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4198 68.9248C24.4198 68.9248 28.5545 47.0279 28.1544 46.497C27.7542 45.9662 26.8207 45.8335 26.2872 45.8335C25.7536 45.8335 21.0852 68.7921 21.0852 68.7921L24.4198 68.9248Z",
    fill: "#ED7218"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.215 66.7739C9.05066 66.7739 0.000217438 75.7788 0.000217438 86.8869C0.000217438 97.9951 9.05066 107 20.215 107C31.3792 107 40.4297 97.9951 40.4297 86.8869C40.4297 75.7788 31.3792 66.7739 20.215 66.7739Z",
    fill: "#FF3381"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0563 94.8561C32.4991 100.3 26.3199 103.339 20.299 103.8C15.8276 104.143 11.3905 103.303 7.03692 102.132C9.25016 104.025 11.8493 105.419 14.6555 106.218C17.4618 107.017 20.4086 107.201 23.2934 106.759C26.1782 106.317 28.9325 105.258 31.367 103.656C33.8015 102.054 35.8584 99.9464 37.3963 97.4781C38.9342 95.0098 39.9166 92.2393 40.2759 89.3573C40.6353 86.4752 40.363 83.5499 39.478 80.7825C38.5929 78.0151 37.1159 75.4712 35.1487 73.3257C33.1815 71.1803 30.7706 69.4842 28.0818 68.3541C30.688 70.112 32.8052 72.4968 34.2368 75.287C36.4066 79.4907 37.0419 84.3775 36.5365 89.0762C36.323 91.0623 35.9064 93.0467 35.0563 94.8561Z",
    fill: "#FF73A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61823 76.3786C5.64063 75.5541 7.44477 74.3667 9.37695 73.3448C11.6738 72.1298 14.3055 71.4868 16.8545 71.1589C21.7481 70.5293 27.9196 70.886 31.5949 74.6166C35.2701 78.3472 35.0594 84.4774 33.1425 88.9817C31.2066 93.5294 26.9045 98.8654 21.7792 99.4112C16.9528 99.925 10.6904 96.23 8.32936 91.997C5.62691 87.1521 9.42862 81.4056 13.8987 79.6424C18.891 77.673 27.0698 79.474 27.5504 85.8259C27.969 91.3518 22.3767 94.713 17.6883 92.5163C15.5967 91.5365 14.0879 89.2118 14.379 86.8306C14.565 85.3088 15.6833 84.1931 17.1624 84.0841C19.5051 83.9118 20.4046 86.9819 18.6124 88.4001C18.5799 88.4205 18.5568 88.4528 18.5482 88.4901C18.5397 88.5274 18.5464 88.5665 18.5668 88.5989C18.5872 88.6313 18.6198 88.6543 18.6572 88.6628C18.6947 88.6713 18.734 88.6646 18.7666 88.6443C21.5542 87.1193 20.1215 82.9819 17.1146 82.9631C12.6627 82.9344 11.7461 87.9478 13.4236 91.2669C15.2272 94.8355 19.741 95.9093 23.285 95.0767C27.2803 94.1382 29.3878 90.1199 29.7246 86.2556C30.1673 81.1746 26.4729 77.8313 22.1284 76.4239C17.3968 74.8912 12.0381 76.0217 8.25315 79.2549C4.58858 82.386 3.23771 87.2454 4.4357 91.9138C5.6731 96.7364 10.7982 100.078 15.0573 101.782C18.1863 103.035 21.5159 103.319 24.7183 102.19C27.9677 101.043 30.5708 98.2257 32.6837 95.5784C36.902 90.2929 38.9356 83.2103 36.4027 76.6864C33.7143 69.7613 26.9187 67.7799 20.2091 67.6751C17.5989 67.6343 14.2982 67.9659 11.2284 68.9025C7.89026 70.6082 5.08688 73.1931 3.12397 76.3753C3.20135 76.4109 3.28548 76.4296 3.37074 76.4302C3.45599 76.4308 3.54037 76.4132 3.61823 76.3786Z",
    fill: "#FF73A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61823 76.1556C5.64063 75.3522 7.44477 74.1952 9.37695 73.1995C11.6738 72.0155 14.3055 71.3898 16.8545 71.0695C21.7481 70.456 27.9196 70.803 31.5949 74.4387C35.2701 78.0743 35.0594 84.0474 33.1425 88.4365C31.2066 92.8677 26.9045 98.0675 21.7792 98.5992C16.9528 99.0999 10.6904 95.4994 8.32936 91.3747C5.62691 86.6539 9.42862 81.0543 13.8987 79.3361C18.891 77.4171 27.0698 79.1721 27.5504 85.3614C27.969 90.7462 22.3767 94.0213 17.6883 91.8808C15.5967 90.926 14.0879 88.6607 14.379 86.3405C14.565 84.8576 15.6833 83.7705 17.1624 83.6643C19.5051 83.4959 20.4046 86.488 18.6124 87.8699C18.5817 87.8907 18.5604 87.9226 18.553 87.9588C18.5457 87.995 18.5528 88.0326 18.5729 88.0637C18.593 88.0947 18.6245 88.1167 18.6607 88.125C18.6969 88.1332 18.7349 88.1271 18.7666 88.1079C21.5542 86.6218 20.1215 82.5903 17.1146 82.5719C12.6627 82.5446 11.7461 87.4291 13.4236 90.6634C15.2272 94.1407 19.741 95.187 23.285 94.3756C27.2803 93.4612 29.3878 89.5457 29.7246 85.7803C30.1673 80.8293 26.4729 77.5714 22.1284 76.2003C17.3968 74.7066 12.0381 75.8077 8.25315 78.9589C4.58858 82.0099 3.23771 86.7451 4.4357 91.2941C5.6731 95.9935 10.7982 99.2495 15.0573 100.91C18.1863 102.131 21.5159 102.408 24.7183 101.307C27.9677 100.19 30.5708 97.4448 32.6837 94.8648C36.902 89.7142 38.9356 82.8132 36.4027 76.4561C33.7143 69.7082 26.9187 67.7775 20.2091 67.6753C17.5989 67.6356 14.2982 67.9588 11.2284 68.8714C7.90912 70.5166 5.10622 73.035 3.12397 76.1533C3.20164 76.188 3.28574 76.2061 3.37086 76.2065C3.45598 76.2069 3.54023 76.1895 3.61823 76.1556Z",
    fill: "#C40E7F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8514 31.3696C97.8514 31.3696 121.273 22.7247 113.341 14.4554C105.408 6.18623 89.9188 23.1006 89.9188 23.1006L97.8514 31.3696Z",
    fill: "url(#paint3_radial_638_1450)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.726 25.251C89.726 25.251 106.273 6.62978 95.3557 3.06551C84.4384 -0.498755 78.8088 21.6867 78.8088 21.6867L89.726 25.251Z",
    fill: "url(#paint4_radial_638_1450)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2738 31.3696C56.2738 31.3696 32.8522 22.7247 40.7853 14.4554C48.7185 6.18623 64.207 23.1006 64.207 23.1006L56.2738 31.3696Z",
    fill: "url(#paint5_radial_638_1450)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3992 25.251C64.3992 25.251 47.8521 6.62978 58.7694 3.06551C69.6868 -0.498755 75.3164 21.6867 75.3164 21.6867L64.3992 25.251Z",
    fill: "url(#paint6_radial_638_1450)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5194 51.15C41.7885 39.0261 48.9189 29.2657 57.9383 21.5958C63.4121 16.9409 69.6115 12.2567 76.9208 12.2565C84.2302 12.2562 90.4293 16.9409 95.9034 21.5957C104.923 29.2654 112.053 39.0261 113.322 51.15C115.591 72.8288 102.331 102.953 76.921 102.954C51.5114 102.954 38.2502 72.8283 40.5194 51.15Z",
    fill: "url(#paint7_radial_638_1450)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.8132 67.8308C47.8577 63.8132 49.2665 59.8395 51.5601 56.3734C53.3422 53.6807 55.6211 51.3502 57.9914 49.1517C64.86 42.7808 72.8691 37.2607 82.0118 35.1274C91.1546 32.9941 102.061 34.2102 108.795 40.7226C109.607 41.5073 110.957 42.9289 111.703 43.7819C109.103 35.7086 103.941 28.9494 97.579 23.198C94.3033 22.4081 89.7365 21.8735 86.3771 21.7806C72.9733 21.41 59.3481 25.3184 48.7008 33.427C47.5951 34.2688 46.5287 35.1621 45.4961 36.0926C42.8809 40.6433 41.0975 45.6531 40.5221 51.1503C39.6261 59.7092 41.1529 69.5837 44.8904 78.4023C45.271 74.8365 45.9137 71.3032 46.8132 67.8308Z",
    fill: "#5D0D75"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M102.228 85.9238C97.9554 92.655 91.2855 97.8183 83.7229 100.419C79.6796 101.796 75.4285 102.47 71.1555 102.413C73.0557 102.775 74.9864 102.956 76.9211 102.954C102.331 102.954 115.591 72.8288 113.322 51.1497C112.141 39.8657 105.882 30.6303 97.7485 23.221C104.093 33.4814 110.25 44.3967 110.4 56.3702C110.458 61.0249 109.59 65.6446 108.457 70.1611C107.078 75.6632 105.271 81.1298 102.228 85.9238Z",
    fill: "#FFADEF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8301 51.9126C93.8301 51.9126 78.0196 25.9115 58.7125 51.9126C58.7125 51.9126 80.8414 46.1689 93.8301 51.9126Z",
    fill: "#5D0D75"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.993 14.1945C112.556 17.067 111.91 20.1329 110.338 22.6065C109.352 24.1585 108.033 25.4694 106.726 26.7662L105.811 27.6748C111.732 24.3879 118.041 19.356 113.34 14.4559C112.867 13.9576 112.327 13.5257 111.737 13.172C111.84 13.5083 111.925 13.8496 111.993 14.1945Z",
    fill: "#FFADEF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.5713 6.63617C96.9909 10.1822 96.4846 13.7647 95.6241 17.2437C98.8958 11.8813 101.312 5.42022 95.8384 3.23995C96.189 4.34669 96.4344 5.48376 96.5713 6.63617Z",
    fill: "#FFADEF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.2255 8.26896C57.2026 6.62576 57.4278 4.98845 57.8935 3.41176C52.5338 5.93085 55.7426 13.0562 59.2871 18.4902C58.2271 15.1533 57.2657 11.7578 57.2255 8.26896Z",
    fill: "#FFADEF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.7843 14.4553C36.0904 19.348 42.3735 24.3718 48.2871 27.6592C46.1527 25.4529 44.3848 22.893 43.2737 20.0443C42.4426 17.9285 42.0186 15.6761 42.0237 13.4044C41.5747 13.7105 41.1593 14.0628 40.7843 14.4553Z",
    fill: "#FFADEF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1649 78.2634C88.031 78.2634 81.4372 84.6583 81.4372 92.5467C81.4372 100.435 88.031 106.83 96.1649 106.83C104.299 106.83 110.893 100.435 110.893 92.5467C110.893 84.6583 104.299 78.2634 96.1649 78.2634Z",
    fill: "#FFADEF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1649 79.7206C88.031 79.7206 81.4372 85.7893 81.4372 93.2754C81.4372 100.761 88.031 106.83 96.1649 106.83C104.299 106.83 110.893 100.761 110.893 93.2754C110.893 85.7893 104.299 79.7206 96.1649 79.7206Z",
    fill: "#5D0D75"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9012 82.8957C89.174 82.8957 82.9099 88.2536 82.9099 94.8629C82.9099 101.472 89.174 106.83 96.9012 106.83C104.628 106.83 110.893 101.472 110.893 94.8629C110.893 88.2536 104.628 82.8957 96.9012 82.8957Z",
    fill: "url(#paint8_radial_638_1450)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.9 82.8958C89.1727 82.8958 82.9085 88.2531 82.9085 94.863C82.91 96.3217 83.2179 97.7639 83.8126 99.0972C84.2794 98.1825 84.8764 97.3395 85.5852 96.5945C87.6671 94.4113 90.5023 93.0813 93.3917 92.1917C97.1276 91.0412 101.154 90.5543 104.961 91.4434C107.125 91.9418 109.148 92.9228 110.875 94.3124C110.539 87.9588 104.412 82.8958 96.9 82.8958Z",
    fill: "#DBA75C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5093 87.7066C93.6625 87.7066 91.3546 89.8935 91.3546 92.5911C91.3546 95.2887 93.6625 97.4756 96.5093 97.4756C99.3562 97.4756 101.664 95.2887 101.664 92.5911C101.664 89.8935 99.3562 87.7066 96.5093 87.7066Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0003 88.9277C94.4245 88.9277 92.3365 90.8412 92.3365 93.2017C92.3365 95.5621 94.4245 97.4756 97.0003 97.4756C99.576 97.4756 101.664 95.5621 101.664 93.2017C101.664 90.8412 99.576 88.9277 97.0003 88.9277Z",
    fill: "#574120"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5283 96.1264C97.3216 97.1856 98.0171 98.211 99.0817 98.4167C100.146 98.6223 101.177 97.9303 101.384 96.8711C101.59 95.8118 100.895 94.7864 99.8302 94.5808C98.7655 94.3751 97.735 95.0671 97.5283 96.1264Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3296 96.2034C88.3315 97.0431 87.3959 99.3355 88.2399 101.324C89.0839 103.312 91.3879 104.243 93.386 103.403C95.3841 102.563 96.3197 100.271 95.4757 98.2826C94.6317 96.2945 92.3277 95.3636 90.3296 96.2034Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3893 78.2634C50.2554 78.2634 43.6615 84.6583 43.6615 92.5467C43.6615 100.435 50.2554 106.83 58.3893 106.83C66.5233 106.83 73.1172 100.435 73.1172 92.5467C73.1172 84.6583 66.5233 78.2634 58.3893 78.2634Z",
    fill: "#FFADEF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3893 79.7206C50.2554 79.7206 43.6615 85.7893 43.6615 93.2754C43.6615 100.761 50.2554 106.83 58.3893 106.83C66.5233 106.83 73.1172 100.761 73.1172 93.2754C73.1172 85.7893 66.5233 79.7206 58.3893 79.7206Z",
    fill: "#5D0D75"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1258 82.8957C51.3986 82.8957 45.1345 88.2536 45.1345 94.8629C45.1345 101.472 51.3986 106.83 59.1258 106.83C66.853 106.83 73.1172 101.472 73.1172 94.8629C73.1172 88.2536 66.853 82.8957 59.1258 82.8957Z",
    fill: "url(#paint9_radial_638_1450)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.1264 82.8958C51.3993 82.8958 45.135 88.2531 45.135 94.863C45.1365 96.3217 45.4445 97.7639 46.0391 99.0972C46.5059 98.1823 47.1029 97.3393 47.8116 96.594C49.8936 94.4109 52.7289 93.0809 55.6183 92.1913C59.3542 91.0408 63.3805 90.5539 67.1878 91.443C69.352 91.9414 71.3741 92.9224 73.1016 94.3119C72.7646 87.9588 66.6378 82.8958 59.1264 82.8958Z",
    fill: "#DBA75C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7339 87.7066C55.8871 87.7066 53.5792 89.8935 53.5792 92.5911C53.5792 95.2887 55.8871 97.4756 58.7339 97.4756C61.5808 97.4756 63.8887 95.2887 63.8887 92.5911C63.8887 89.8935 61.5808 87.7066 58.7339 87.7066Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2249 88.9277C56.6492 88.9277 54.5611 90.8412 54.5611 93.2017C54.5611 95.5621 56.6492 97.4756 59.2249 97.4756C61.8006 97.4756 63.8887 95.5621 63.8887 93.2017C63.8887 90.8412 61.8006 88.9277 59.2249 88.9277Z",
    fill: "#574120"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7412 96.184C59.5666 97.249 60.2928 98.2532 61.3632 98.4269C62.4336 98.6007 63.4428 97.8781 63.6174 96.8131C63.792 95.7481 63.0659 94.7439 61.9955 94.5702C60.9251 94.3965 59.9158 95.119 59.7412 96.184Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7675 96.1207C50.7233 96.8425 49.6543 99.0763 50.3797 101.11C51.1051 103.144 53.3502 104.208 55.3944 103.486C57.4386 102.764 58.5076 100.53 57.7822 98.4965C57.0568 96.4626 54.8117 95.3989 52.7675 96.1207Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4121 50.2866C88.4121 50.2866 91.339 46.0529 90.643 44.529C89.9469 43.0051 84.2381 41.8969 83.2635 42.59C82.2888 43.2832 81.729 49.3176 81.729 49.3176C81.729 49.3176 87.0198 49.8718 88.4121 50.2866Z",
    fill: "#FFF5DE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M64.428 50.8408C64.428 50.8408 61.2286 46.607 61.9248 45.0831C62.621 43.5592 68.3296 42.4509 69.3043 43.1441C70.279 43.8372 71.1113 49.8716 71.1113 49.8716C71.1113 49.8716 65.8206 50.4252 64.428 50.8408Z",
    fill: "#FFF5DE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9955 104.114C29.3183 104.787 29.3183 105.88 29.9955 106.553C30.6727 107.227 31.7706 107.227 32.4477 106.553C33.1249 105.88 33.1249 104.787 32.4477 104.114C31.7706 103.44 30.6727 103.44 29.9955 104.114Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_638_1450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(600.928 207.524) rotate(43.7145) scale(23.8406 47.8242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_638_1450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.389 196.315) rotate(76.0564) scale(64.8063 26.7463)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_638_1450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.7554 300.842) rotate(104.912) scale(70.0822 24.734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_638_1450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.207 25.3052) rotate(180) scale(33.867 33.6804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_638_1450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6544 73.9337) rotate(154.554) scale(33.0617 34.5024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_638_1450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(322.248 26.8405) scale(33.8674 33.6804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_638_1450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.48 101.929) rotate(25.4456) scale(33.0617 34.5024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_638_1450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.5589 71.9352) rotate(180) scale(57.996 57.6834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_638_1450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.801 105.37) rotate(-180) scale(30.0092 29.8462)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_638_1450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0402 105.37) rotate(-180) scale(30.0092 29.8462)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationSs);
export default __webpack_public_path__ + "static/media/applicationSS.9272ee437958862d4077a4dc223298d2.svg";
export { ForwardRef as ReactComponent };